module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "caption text-center"
  }, [_c('center', [_c('span', {
    staticClass: "black--text",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v(" AppointmentGuru version: " + _vm._s(_vm.version))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadRequired),
      expression: "reloadRequired"
    }],
    staticStyle: {
      "position": "fixed",
      "top": "5px",
      "right": "5px",
      "z-index": "10"
    },
    attrs: {
      "small": "",
      "success": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Update available. Please reload")]), _vm._v(" "), (_vm.withReload) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "block": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Get latest version")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729c572e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Version.vue
// module id = 1466
// module chunks = 9